import { BRAND_NAME } from "@/lib/brand";

/**
 * Renders the OutRepR wordmark with the trailing letter accented in
 * brand-orange. Source of truth for the visible wordmark across the
 * app — anywhere the name is rendered as DISPLAY text (not alt
 * attributes / metadata / aria-labels) should use this component
 * rather than `{BRAND_NAME}` directly.
 *
 * ## Why a component
 *
 * Pre-v9.203 each render site rolled its own `BRAND_NAME.slice(0,
 * -1)` + `<span className="text-brand">` pair. Most surfaces drifted
 * and rendered the name as plain text — landing page, login, privacy,
 * terms, onboarding wizard, and inline brand mentions on the active-
 * workout card and the settings screen all shipped without the
 * orange-R accent. Centralising the slice + accent in one component
 * means new surfaces that want the wordmark just import this; the
 * accent can't drift.
 *
 * ## Styling
 *
 * The component renders into a `<span>` so it can be embedded inline
 * anywhere text flows. It inherits the surrounding text's font-size,
 * weight, and tracking — only the COLOUR of the last letter is
 * overridden. Pass `className` to add any wrapper-level styling
 * (e.g. font-weight) that should apply to BOTH halves of the
 * wordmark.
 */
export function BrandWordmark({ className }: { className?: string }) {
  return (
    <span className={className}>
      {BRAND_NAME.slice(0, -1)}
      <span className="text-brand">{BRAND_NAME.slice(-1)}</span>
    </span>
  );
}
